import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CustomerContectService } from '../../customer-contect.service';
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import notify from "devextreme/ui/notify";

@Component({
  selector: 'app-add-custoemr-contect-login',
  templateUrl: './add-custoemr-contect-login.component.html',
  styleUrls: ['./add-custoemr-contect-login.component.scss']
})
export class AddCustoemrContectLoginComponent implements OnInit {
  loading: boolean;
  customerForm: FormGroup;
  customerContactLoginId: any;
  customerBranches: any[];
  @ViewChild("saveSwal") private saveSwal: SwalComponent;
  passwordPattern: any = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private customerService: CustomerContectService
  ) { }

  ngOnInit() {
    this.customerBranches = [];
    this.customerForm = new FormGroup({
      "customerId": new FormControl(JSON.parse(localStorage.getItem('userData')).customerId, []),
      "userName": new FormControl(null, [Validators.required]),
      "userPassword": new FormControl(null, [Validators.required, Validators.pattern(this.passwordPattern)]),
      "customerBranchList": new FormControl(null, [Validators.required]),
      "active": new FormControl(true, []),
      "isAdmin": new FormControl(false, []),

    });

    if (this.activatedRoute.snapshot.params.id) {
      this.customerContactLoginId = this.activatedRoute.snapshot.params.id;
      this.getCustomerContactLoginById(
        this.activatedRoute.snapshot.params.id
      );
    }

    this.getCustomerBranchByCustomerId(JSON.parse(localStorage.getItem('userData')).customerId);
  }


     /**
     * @name getAllCustomerBranches
     * @returns CustomerBranchRelation
     */
    getCustomerBranchByCustomerId(customerId: number) {
    this.loading = true;
    this.customerService.getCustomerBranchByCustomerId(customerId)
    .then(response => {
      if (response.data.completed) {
        // this.allMaterials = response.data.payload;
        if (response.data.payload.length > 0) {
          const list = [];
          response.data.payload.forEach(element => {
            if (element.active) {
              list.push(element);
            }
          });
          this.customerBranches = list;
        } else {
          if (response.data.payload.active) {
            this.customerBranches = response.data.payload;
          }
        }
        this.loading = false;
      }
    })
    .catch(err => {
      this.loading = false;
      console.error('Error:  ', err);
    });
  }
  


  /**
* @name getCustomerContactLoginById
* @param {number} customerContactLoginId
* @returns fetch admin from by customerContactLoginId
*/
  getCustomerContactLoginById(customerContactLoginId: number) {
    this.loading = true;
    this.customerService
      .getCustomerContactLoginById(customerContactLoginId)
      .then((response: any) => {
        if (response.data.completed) {
          console.log('edit', response.data.payload)
          this.loading = false;
          this.customerForm.get('customerId').setValue(response.data.payload.customerId);
          this.customerForm.get('userName').setValue(response.data.payload.userName);
          this.customerForm.get('userPassword').setValue(response.data.payload.userPassword);
          let selectedId = [];
          if (response.data.payload.customerBranchList.length > 0) {
            response.data.payload.customerBranchList.forEach(element => {
              selectedId.push(element.customerBranchId);
            });
          }
          this.customerForm.get('customerBranchList').setValue(selectedId);
          this.customerForm.get('active').setValue(response.data.payload.active);
          this.customerForm.get('isAdmin').setValue(response.data.payload.isAdmin);
        } else {
          this.loading = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: 'success'
          };
          notify(option);
          console.error(response);
        }
      })
      .catch(error => {
        this.loading = false;
        console.log(error);
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.error,
          type: 'error'
        };
        notify(option);
      });
  }


  /**
    *@name  addCustomerContactLogin
    *@param form
    *@desc add customer Contact form
   */
  addCustomerContactLogin(form: FormGroup) {
    this.loading = true;
    let payload = {};
    // let customerBranchRelationList = [];
    
    // form.value.customerBranchRelationList.forEach(element => {
    //   customerBranchRelationList.push(
    //     {
    //       "customerBranchRelationId": 0,
    //       "customerBranchId": element,
    //       "customerBranchName": null,
    //       "customerBranchArabicName": null,
    //       "customerContactLoginId": this.customerContactLoginId ? this.customerContactLoginId : 0,
    //       "active": true
    //     }
    //   )
    // });
    payload = form.value;

    payload['customerContactLoginId'] = this.customerContactLoginId ? this.customerContactLoginId : 0;
    //  payload['customerBranchRelationList'] = customerBranchRelationList;
    console.log('payload', payload);
    this.customerService.addCustomerContactLogin(payload, this.customerContactLoginId).then((response) => {
      console.log(response);
      if (response.data.completed) {
        this.loading = false;
        this.saveSwal.swalOptions = {
          icon: 'success',
          titleText: response.data.message,
          showConfirmButton: false,
          showCancelButton: false,
          timer: 1500
        };
        this.saveSwal.fire().then((res: any) => {
          this.router.navigate(['./portal/customers/customer-contact-login']);
          this.customerForm.reset();
        });
      }
      else {
        this.loading = false;
        const option = {
          width: 300,
          displayTime: 2000,
          message: response.data.message,
          type: 'error'
        };
        notify(option);
      }
    })
    .catch(error => {
      this.loading = false;
      const option = {
        width: 300,
        displayTime: 3000,
        message: error.error,
        type: "error"
      };
      notify(option);
    });
  }

}
